// "Add to calendar": a Google Calendar event link, built once for every
// booking page. Times are UTC ("…Z"), so the calendar shows the event in
// the customer's own zone; every value is URI-encoded (v1 only swapped
// spaces for "+", so an "&" in a class name cut the link short). Pure.

const MINUTE = 60_000;

/** "20260910T100000Z", Google Calendar's date form. */
const stamp = (ms: number) => new Date(ms).toISOString().replace(/[-:]|\.\d{3}/g, "");

export function googleCalendarLink(event: {
  title: string;
  start: string;
  /** Minutes. */
  duration: number;
  details?: string;
  location?: string;
}): string | undefined {
  const start = new Date(event.start).getTime();
  if (!Number.isFinite(start)) return undefined;
  const query = new URLSearchParams({
    action: "TEMPLATE",
    text: event.title,
    dates: `${stamp(start)}/${stamp(start + event.duration * MINUTE)}`,
  });
  if (event.details) query.set("details", event.details);
  if (event.location) query.set("location", event.location);
  return `https://calendar.google.com/calendar/render?${query.toString()}`;
}
